export default "__VITE_ASSET__ef2962ba__"